// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G4tC","index":"styles_index__1nfrG"};